import { render, staticRenderFns } from "./BaseTag.vue?vue&type=template&id=642d8652&"
import script from "./BaseTag.vue?vue&type=script&lang=ts&"
export * from "./BaseTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports